import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"
import SbImageService, { isSvg } from "../../helpers/SbImageService"

const SuperBlock = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div
      className={`lazyload super-grid__block ${
        blok.crop ? blok.crop : className
      } ${blok.is_image ? " super-grid__block--image" : ""}`}
      data-bg={SbImageService(blok.bg_image)}
      style={
        isSvg(blok.bg_image)
          ? { backgroundImage: `url("${blok.bg_image}")` }
          : null
      }
    >
      {blok.content &&
        blok.content.map((c) =>
          React.createElement(Components(c.component), {
            key: c._uid,
            blok: c,
          })
        )}
    </div>
  </SbEditable>
)

SuperBlock.propTypes = {
  blok: PropTypes.shape({
    is_image: PropTypes.bool,
    bg_image: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
    crop: PropTypes.string,
  }).isRequired,
}

export default SuperBlock
